import { render } from "./SideMenuCategoryList.vue?vue&type=template&id=71411f11&scoped=true"
import script from "./SideMenuCategoryList.vue?vue&type=script&lang=js"
export * from "./SideMenuCategoryList.vue?vue&type=script&lang=js"

import "./SideMenuCategoryList.vue?vue&type=style&index=0&id=71411f11&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71411f11"]])

export default __exports__